import { Permission } from '@cims-online/shared'
import { DefaultMutationHookOptions } from 'utils/defaults'
import { RemoveRowActionOptions } from 'components/CIMSTable/CIMSTableContext/types/actions/row'
import { useCASTypesContext } from '../../../../CASTypesContext'
import { simpleRemoveNotification } from 'hooks/notificationHandler'
import { useSoftRemoveCasTypeMutation } from 'schema'
import { CASType } from '../../../../CASTypesContext/types'

export function useRemove(): RemoveRowActionOptions<CASType> {
  const { refetch } = useCASTypesContext()
  const [remove] = useSoftRemoveCasTypeMutation({
    ...DefaultMutationHookOptions,
    onCompleted: ({
      softRemoveCASType: {
        type: { name },
      },
    }) => simpleRemoveNotification(name),
  })
  return {
    disabled: ({ submittals }) =>
      !!submittals.length
        ? {
            message:
              'Submittal types cannot be deleted if they are associated with one or more submittals',
          }
        : false,
    permission: Permission.RemoveRestoreCASType,
    onRemove: async ({ id }) => {
      await remove({ variables: { id } })
      refetch()
    },
  }
}
